import React, { Component } from 'react'

const FuncIntro = ({funcList}) => (
  <div>
    <div className='func-show-wrap'>
      <div className='func-intro'>
        <h3>功能介绍</h3>
        {
          funcList[0].desc ?
            <p>{funcList[0].desc}</p> :
            null
        }
        <div className='intro-list'>
          <img style={{width: '100%', height: '100%'}} alt='' src={funcList[0].image} onContextMenu={($event) => $event.preventDefault()}/>
        </div>
      </div>
    </div>

    <style jsx>{`
      .func-show-wrap {
        width: 100%;
        background: #f5f5f5;
      }

      .func-intro {
        margin: 0 auto;
        width: 1200px;
        padding: 93px 0 108px 0;
      }

      .func-intro>h3{
        font-size: 32px;
        color: #333;
        text-align: center;
        margin-bottom: 54px;
      }

      .func-intro>p {
        width: 700px;
        color: #747578;
        font-size: 14px;
        line-height: 20px;
        margin: 0 auto;
        text-align: center;
      }

      .intro-list {
        width: 100%;
        margin-top: 36px;
        display: flex;
        justify-content: space-between;
      }

      .intro-item {
        width: 585px;
        height: 340px;
        background: #93F086;
      }

      .func-show {
        margin: 0 auto;
        width: 1200px;
        height: 100%;
        padding: 85px 0 109px 0;
      }

      .func-show>h2 {
        font-size: 32px;
        color: #333;
        text-align: center;
        margin-bottom: 54px;
      }
    `}</style>
  </div>
)

export default FuncIntro
